import AppSidebar from '../../components/layout/AppSidebar';

interface MainSidebarProps {
  collapsed?: boolean;
  onToggle?: () => void;
}

/**
 * MainSidebar Component
 * Wrapper for the unified AppSidebar navigation
 */
export default function MainSidebar(_props: MainSidebarProps) {
  return <AppSidebar />;
}
